import { TypographyProps } from '@mui/material'
import { GridColDef } from '@mui/x-data-grid-premium'
import { BaseColumnConfig } from '../types'
import { baseColumnConfig } from './baseColumnConfig'
import { TextCell } from './TextCell'
import type { GridValidRowModel } from '@mui/x-data-grid/models/gridRows'

export type TextColumnConfig<T extends GridValidRowModel> = BaseColumnConfig<T, 'text'> & {
  columnType: 'text'
  appendText?: string
  textVariant?: TypographyProps['variant']
  color?: TypographyProps['color']
  filterOperators?: GridColDef<T>['filterOperators']
  groupingValueGetter?: GridColDef<T>['groupingValueGetter']
  editable?: boolean
}

export const getTextColumn = <T extends GridValidRowModel>({ style, ...config }: TextColumnConfig<T>): GridColDef<T> => ({
  ...baseColumnConfig,
  ...style,
  ...config,
  groupingValueGetter: config.groupingValueGetter ?? config.valueGetter,
  renderCell: (params) => (
    <TextCell
      dataTestId={config.getDataTestId ? config.getDataTestId(params) : undefined}
      variant={config.textVariant}
      color={config.color}
    >
      {params.formattedValue}
      {params.formattedValue && config.appendText ? config.appendText : ''}
    </TextCell>
  ),
})
